import React from 'react';
import { WithWistiaContext } from 'utils/WistiaContext';
import PlayButton from 'components/Core/WistiaVideo/components/PlayButton';
import WistiaVideoModal from '../components/WistiaVideoModal';
import { PlayButtonPopoverContainer } from './styles';

const PlayButtonPopover = ({ className }) => (
  <PlayButtonPopoverContainer className={`wistia-video--wrapper ${className || ''}`}>
    <PlayButton alwaysShow />
    <WistiaVideoModal />
  </PlayButtonPopoverContainer>
);

export default WithWistiaContext(PlayButtonPopover);
